import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import {
  PageToPageListDefaultView,
  PageToPageListDefaultViewProps,
} from '../partials/PageToPageList/PageToPageListDefaultView';

function PageToPageDefault({ assignments, footerLink }: PageToPageListDefaultViewProps) {
  return <PageToPageListDefaultView assignments={assignments} footerLink={footerLink} />;
}

export const PageToPageDefaultView = asView(PageToPageDefault);
export type PageToPageDefaultView = ComponentProps<typeof PageToPageDefaultView>;
